import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect, useRef } from 'react';
import { getSummaryForViewMode } from '../../../Attachments/InlineAttachment';
import { LOAD_TRANSFORMERS } from '../transformers';
import { $convertFromMarkdownString } from '@lexical/markdown';

import { useImpressionEditorContext } from '../../Context';

export const EditingPlugin = () => {
  const { isEditing, activeImpression, viewMode } =
    useImpressionEditorContext();
  const [editor] = useLexicalComposerContext();

  const editorContent =
    activeImpression?.reviewDiffDocument ?? activeImpression?.summary ?? '';

  const isEditingRef = useRef(isEditing);

  useEffect(() => {
    if (isEditingRef.current === isEditing) {
      return;
    }
    if (isEditing) {
      editor.setEditable(true);
    } else {
      editor.setEditable(false);
      editor.update(() => {
        $convertFromMarkdownString(
          getSummaryForViewMode(editorContent, viewMode),
          LOAD_TRANSFORMERS,
        );
      });
    }
    isEditingRef.current = isEditing;
  }, [isEditing, editor, editorContent, viewMode]);

  return null;
};
